export default __webpack_public_path__ + "static/top3-70e89629725bc9d8d631dbbeb560c305.svg";